import { render, staticRenderFns } from "./PlusMumber.vue?vue&type=template&id=4b16849f&"
import script from "./PlusMumber.vue?vue&type=script&lang=js&"
export * from "./PlusMumber.vue?vue&type=script&lang=js&"
import style0 from "./PlusMumber.vue?vue&type=style&index=0&id=4b16849f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports